import { ImageTextSection } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock ImageTextSection
 * @param overrides - Partial fields to override defaults
 * @returns Complete ImageTextSection mock
 */
export function createImageTextSection(
  overrides: Partial<ImageTextSection> = {}
): ImageTextSection {
  return {
    _uid: '5a836061-95a6-4f8a-b4ce-a151048d909c',
    text: createStoryblokRichtext(
      'Incididunt laborum eu magna voluptate sit. Aliqua laboris et irure irure nulla id.'
    ),
    image: createStoryblokAsset({
      id: 8907064,
      filename:
        'https://a.storyblok.com/f/228071/1920x1080/8f14388a3a/design_development.jpeg',
      src: 'https://a.storyblok.com/f/228071/1920x1080/8f14388a3a/design_development.jpeg',
      width: 1920,
      height: 1080,
      aspect_ratio: 1.78,
      content_type: 'image/jpeg',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    button: [],
    headline: 'Do ipsum laborum eu esse esse excepteur esse ipsum.',
    component: 'image-text-section',
    image_layout: 'proportional',
    reverse_layout: false,
    background_color: 'white',
    _editable:
      '<!--#storyblok#{"name": "image-text-section", "space": "228071", "uid": "5a836061-95a6-4f8a-b4ce-a151048d909c", "id": "300939517"}-->',
    ...overrides,
  }
}
